/* cl-responsive: porte do responsive-layout-controls.js do Horizon do concorrente. O padding
   mobile das secoes NAO esta no CSS: o tema le data-responsive-mobile-padding="t,r,b,l" e
   escreve style.padding (valores > 20px viram max(20px, spacing-scale * N)). Tambem fecha no
   mobile / abre no desktop os acordeoes .group-block__mobile-accordion (especificacoes da PDP). */
(function () {
  if (window.__clResp) return; window.__clResp = true;
  /* harness de medicao (/password + automacao): reduced-motion -> o slider de depoimentos (autoplay
     de 3s) fica no 1o slide, como o HTML servido dele; sem isso a foto pega um slide aleatorio */
  if (navigator.webdriver && location.pathname.indexOf('/password') === 0 && window.matchMedia) {
    var _mm = window.matchMedia.bind(window);
    window.matchMedia = function (q) { if (/prefers-reduced-motion:\s*reduce/.test(q)) { var r = _mm(q); return { matches: true, media: q, addEventListener: function () {}, removeEventListener: function () {}, addListener: function () {}, removeListener: function () {}, onchange: null, dispatchEvent: function () { return false; } }; } return _mm(q); };
  }
  var MQ = window.matchMedia('(max-width: 749px)'), SEL = '[data-responsive-mobile-padding]', ACC = '.group-block__mobile-accordion';
  var ORIG = new WeakMap(), INIT = new WeakSet();
  function val(v) { var p = parseFloat(v) || 0; return p > 20 ? 'max(20px, calc(var(--spacing-scale, var(--spacing-scale-md)) * ' + p + 'px))' : p + 'px'; }
  function list(root, sel) { var a = []; if (root instanceof Element && root.matches(sel)) a.push(root); if (root.querySelectorAll) a.push.apply(a, root.querySelectorAll(sel)); return a; }
  function pad(root) {
    list(root || document, SEL).forEach(function (el) {
      if (!ORIG.has(el)) ORIG.set(el, el.style.padding);
      if (!MQ.matches) { var o = ORIG.get(el); if (o) el.style.padding = o; else el.style.removeProperty('padding'); return; }
      var v = (el.getAttribute('data-responsive-mobile-padding') || '').split(',').map(val);
      if (v.length === 4) el.style.setProperty('padding', v.join(' '));
    });
  }
  function acc(root) {
    list(root || document, ACC).forEach(function (a) {
      if (MQ.matches) { if (!INIT.has(a) || a.dataset.responsiveDesktopOpen === 'true') { a.removeAttribute('open'); delete a.dataset.responsiveDesktopOpen; } }
      else { a.setAttribute('open', ''); a.dataset.responsiveDesktopOpen = 'true'; }
      INIT.add(a);
    });
  }
  function run() { pad(document); acc(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  run();
  if (MQ.addEventListener) MQ.addEventListener('change', run);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      if (m.type === 'attributes' && m.target instanceof Element) { pad(m.target); return; }
      m.addedNodes.forEach(function (n) { if (n instanceof Element) { pad(n); acc(n); } });
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-responsive-mobile-padding'], childList: true, subtree: true });
})();
